export default "__VITE_ASSET__Bm03W70$__"